import { webapi } from '@/api/webapi.ts';
import { cancelSwapRfs } from '@/store/swap/api/cancelSwapRfs.ts';
import { checkSwapByTradeCapture } from '@/store/swap/api/checkSwapByTradeCapture.ts';
import { executeSwapRfs } from '@/store/swap/api/executeSwapRfs.ts';
import { requestSwapRfs } from '@/store/swap/api/requestSwapRfs.ts';

export const swapApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkSwapByTradeCapture: checkSwapByTradeCapture(builder),

    requestSwapRfs: requestSwapRfs(builder),
    cancelSwapRfs: cancelSwapRfs(builder),
    executeSwapRfs: executeSwapRfs(builder),
  }),
});

export const {
  useCheckSwapByTradeCaptureMutation,
  useRequestSwapRfsMutation,
  useCancelSwapRfsMutation,
  useExecuteSwapRfsMutation,
} = swapApi;
